<template>
  <div class="user-box">
    <div class="left-list">
      <div class="avatar">
        <div class="head">
          <img src="@img/user_default.png" alt>
        </div>
        <div class="username">{{userAcount}}</div>
        <!-- <div class="point">
          积分：
          <span>{{totalPoint?totalPoint:'0'}}</span>
        </div> -->
      </div>
      <div class="list">
        <ul v-for="item in list" :key="item.id">
          <li
            :class="currentIndex == item.id?'current':''"
            @click="showMyData(item.id)"
          >{{item.title}}</li>
        </ul>
      </div>
    </div>
    <div class="right-content">
      <div class="title">{{titleList[currentIndex]}}</div>
      <div class="content" v-if="currentIndex !=1">
        <a-row class="head">
          <a-col :span="10" class="course">{{currentIndex != 4?'课程信息':'名师'}}</a-col>
          <a-col :span="5" v-if="currentIndex == 2">收藏时间</a-col>
          <a-col :span="5" v-if="currentIndex == 3">最后学习时间</a-col>
          <a-col :span="5" v-if="currentIndex == 0">购买时间</a-col>
          <a-col :span="5" v-if="currentIndex !=4">价格</a-col>
          <a-col :span="4"></a-col>
        </a-row>
        <UserShow
          v-for="item in courseList"
          :key="item.id"
          :item="item"
          :currentIndex="currentIndex"
        />
        <div class="no-content" v-if="courseList.length < 1">暂无课程</div>

      </div>
      <div class="content" v-if="currentIndex == 1" style="padding:20px">
        <div class="comment-list" v-for="(item,index) in question" :key="index">
          <CourseQuesAns :item="item" />
        </div>

        <div class="no-content" v-if="question.length < 1">暂无评论</div>
      </div>

      <!-- <div class="content vip" v-if="currentIndex ==1">
        <div class="vip-title">我的会员</div>
        <div class="vip-content">会员到期时间：{{end_time?end_time:'暂未开通会员'}}</div>
        <div class="vip-title">会员特权</div>
        <div class="vip-content">可免费观看带有【VIP免费】标志视频</div>
        <div class="vip-title">选择会员套餐</div>
        <a-row class="vip-group">
          <a-col class="vip-item" :span="6" v-for="(item, index) in vipList" :key="index">
            <div
              :class="vipActive == index ? 'vip-box active watch':'vip-box wacth'"
              @click="buyVip(index,item.id)"
            >
              <div>{{item.title}}</div>
              <div class="vip-price">
                {{item.price}}
                <span>元</span>
              </div>
              <img src="@img/choose.png" v-show="vipActive == index" alt>
            </div>
          </a-col>
          <a-col class="vip-item" :span="6"></a-col>
        </a-row>
        <div class="vip-title">选择支付方式</div>
        <div class="vip-check">
          <a-checkbox :checked="wxChecked" @change="wxChange">
            <img src="@img/wechat_pay.png" alt>
          </a-checkbox>
          <a-checkbox :checked="aliChecked" @change="aliChange()">
            <img src="@img/alipay.png" alt>
          </a-checkbox>
        </div>
        <div class="pay-box">
          <canvas class="code" ref="canvas"></canvas>
          <p>通过微信扫一扫</p>
          <p>扫描二维码进行支付</p>
        </div>
        <div class="complete-btn" @click="complete(order_no)">支付完成</div>
      </div> -->
    </div>
    <a-alert :message="errmsg" v-if="errshow" class="errshow" type="error" showIcon />
    <div class="shades" v-show="showShades"></div>
    <div class="reply" v-show="showShades">
      <p>{{replyTitle}}：</p>
      <a-textarea class="reply-box" maxlength="101" @input="changeInput()" onchange="this.value=this.value.substring(0, 200)" onkeydown="this.value=this.value.substring(0, 200)" onkeyup="this.value=this.value.substring(0, 200)" v-model="message" placeholder="请输入评论" />
      <a-button class="reply-btn" type="primary" block @click="commitReply">提交</a-button>
      <a-button class="reply-btn" block @click="cancel">取消</a-button>
    </div>
  </div>
</template>
<script>
import UserShow from "./components/UserShow.vue";
import CourseQuesAns from "./components/CourseQuesAns.vue";
import QRCode from "qrcode";
import { group_sign,getCookie } from '../../utils/tool';
import { mapState } from "vuex";
export default {
  name: "pageUser",
  components: {
    UserShow,
    CourseQuesAns
  },
  data() {
    return {
      list: [
        { title: "我的课程", id: 0 },
        { title: "我的评论", id: 1 }
        // { title: "我的会员", id: 1 },
        // { title: "我的收藏", id: 2 },
        // { title: "课程学习记录", id: 3 },
        // { title: "关注的老师", id: 4 }
      ],
      titleList: ["我的课程", "我的评论", "我的收藏", "学习记录", "我的关注"],
      currentIndex: 0,
      courseList: [],
      totalPoint: 0,
      vipList: [],
      vipActive: 0,
      wxChecked: true,
      aliChecked: false,
      payList: {},
      order_no: "",
      end_time: "",
      userAcount: "",
      student_id: Number(getCookie('studentId')),
      userName: getCookie('userAcount'),
      errmsg: "",
      errshow: false,
      question: [],
      showShades: false,
      replyTitle: "评论",
      comment_id: 0,
      course_id: 0,
      message: "",
    };
  },
  watch: {
    $route(){
      this.currentIndex= this.$route.query.id
    },
    currentIndex() {
      // console.log("重新请求" + this.currentIndex + "的数据")
      this.showMyData(this.currentIndex)
    }
  },
  computed: {
    ...mapState(["isLogin"])
  },
  created() {
    
  },
  methods: {
    changeInput(){
      if (this.message.length > 100 ) {
        alert('输入字数不能超过100')
      }
    },
    showReply(comment_id, course_id, title) {
      if (title) {
        this.replyTitle = "回复" + title;
        this.target_name = title
      }
      if (comment_id) {
        this.comment_id = comment_id;
      }
      if (course_id) {
        this.course_id = course_id;
      }
      if (this.isLogin) {
        this.showShades = true;
      } else {
        this.$root.Bus.$emit("showLogin")
      }
    },
    
    commitReply(){
      var param = group_sign({comment_id:this.comment_id,content:this.message,student_id:this.student_id,course_id:this.course_id,user_name:this.userAcount,
      target_name: this.target_name})
      this.$axios.post(this.$Api.apiClientMyCommentReply, param).then(
        res => {
          if (res.data.errcode == 0) {
            this.$message.success("回复成功！")
            this.showShades = false
            this.showMyData(1)
          }
        }
      )
    },

    cancel() {
      this.message = "";
      this.showShades = false;
    },
    //展示数据
    showMyData(id) {
      this.currentIndex = id;
      let that = this;
      var param = group_sign({student_id: that.student_id})
      this.courseList = []
      switch (id) {
        case 0:
          this.$axios.post(this.$Api.getAuthCourseList, param).then(
            res => {
              if(res.data.errcode == 0) {
                that.courseList = res.data.result.list || []
              } else if(res.data.errcode == 403) {
                that.$message.error(res.data.errmsg)
                let timeErrors = setTimeout(() => {
                  this.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              }
            }
          )
          break;
        case 1:
          this.$axios.post(this.$Api.getMyMessageListReply, param).then(
            res => {
              if(res.data.errcode == 0) {
                that.question = res.data.result.list || []
              }
            }
          )
          break;
        case 2:
          this.$axios.post(this.$Api.getMycollectCourseList, param).then(
            res => {
              if(res.data.errcode == 0) {
                that.courseList = res.data.result
              } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  this.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              }
            }
          )
          break;
        case 3:
          this.$axios.post(this.$Api.getStuPlayVideoRecord, param).then(
            res => {
              if(res.data.errcode == 0) {
                that.courseList = res.data.result.list
              } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  this.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              }
            }
          )
          break;
        case 4:
          this.$axios.post(this.$Api.getMyTeacher, param).then(
            res => {
              if(res.data.errcode == 0) {
                that.courseList = res.data.result
              } else if(res.data.errcode == 403) {
                that.errshow = true;
                that.errmsg = res.data.errmsg;
                let timeError = setTimeout(() => {
                  that.errmsg = "";
                  that.errshow = false;
                  clearTimeout(timeError);
                }, 2000);
                let timeErrors = setTimeout(() => {
                  this.$root.Bus.$emit("showLogin")
                  clearTimeout(timeErrors)
                }, 2000)
              }
            }
          )
          break;
        default:
          break;
      }
    },
    qrcode(code) {
      QRCode.toCanvas(
        this.$refs.canvas,
        code,
        { errorCorrectionLevel: "H" },
        error => {
          if (error) {
            console.log(error);
          }
        }
      );
    },
    wxChange() {
      this.aliChecked = false;
      this.wxChecked = true;
    },
    aliChange() {
      this.wxChecked = false;
      this.aliChecked = true;
      window.open(this.payList.skip_url, "_blank");
    },
  },
  beforeMount() {
    this.currentIndex = parseInt(this.$route.query.id) ? parseInt(this.$route.query.id) : this.currentIndex
    this.showMyData(this.currentIndex);
    this.userAcount = getCookie('userAcount')
  }
};
</script>
<style lang="less" scoped>
.user-box {
  width: 1180px;
  margin: 0 auto;
  padding-top: 15px;
  display: flex;
  .left-list {
    flex: 3;
    height: 460px;
    background-color: #fff;
    margin-right: 20px;
    padding-bottom: 20px;
    .avatar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 200px;
      .head {
        position: relative;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        overflow: hidden;
        img {
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          -webkit-transform: translate3d(0, -50%, 0);
          -moz-transform: translate3d(0, -50%, 0);
          -o-transform: translate3d(0, -50%, 0);
          -ms-transform: translate3d(0, -50%, 0);
          transform: translate3d(0, -50%, 0);
        }
      }
      .username {
        margin-top: 10px;
      }
      .point {
        margin-top: 10px;
        span {
          color: #3b9dff;
        }
      }
    }
    .list {
      padding: 0 15px;
      ul {
        li {
          padding-left: 20px;
          border-left: 4px solid #fff;
          color: #333;
          height: 48px;
          line-height: 48px;
          cursor: pointer;
        }
        .current {
          color: #3b9dff;
          border-color: #3b9dff;
          background: #eef6ff;
        }
      }
    }
  }
  .right-content {
    flex: 8;

    .title {
      font-size: 22px;
      font-weight: normal;
      margin-bottom: 16px;
      padding-left: 12px;
      color: #333;
    }
    .content {
      min-height: 200px;
      background-color: #fff;
      .head {
        color: #999;
        font-size: 14px;
        height: 48px;
        line-height: 48px;
        .course {
          padding-left: 15px;
        }
      }
    }
    .vip {
      padding-left: 20px;
      padding-top: 20px;
      .vip-title {
        font-size: 18px;
        padding-left: 12px;
        border-left: 4px solid #3b9dff;
        margin-bottom: 10px;
      }
      .vip-content {
        margin-bottom: 20px;
      }
      .vip-group {
        height: 160px;
        margin-bottom: 20px;
        .vip-item {
          padding: 15px;
          height: 100%;
          .vip-box {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            border: 1px solid #e6e6e6;
            border-radius: 2px;
            padding: 20px;
            text-align: center;
            margin-bottom: 20px;
            position: relative;
            &:hover {
              border-color: #f5a623;
            }
            img {
              position: absolute;
              width: 32px;
              height: 32px;
              right: 0;
              bottom: 0;
            }
            .vip-price {
              color: #f5a623;
              font-size: 22px;
              span {
                font-size: 14px;
              }
            }
          }
          .active {
            border-color: #f5a623;
          }
          .wacth {
            cursor: pointer;
          }
        }
      }
      .vip-check {
        padding-top: 10px;
        img {
          width: 90px;
          height: 24px;
        }
      }
      .pay-box {
        height: 360px;
        width: 290px;
        box-sizing: border-box;
        border: 1px solid #efefef;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        .code {
          width: 240px !important;
          height: 240px !important;
        }
        p {
          text-align: center;
          color: #999;
          font-size: 12px;
          margin-top: 10px;
        }
      }
      .complete-btn {
        width: 200px;
        cursor: pointer;
        height: 48px;
        line-height: 48px;
        display: block;
        margin: 0 auto;
        margin-top: 40px;
        background: #f5a623;
        text-align: center;
        color: #fff;
      }
    }
    .no-content {
      text-align: center;
    }
  }
  .errshow {
    position: fixed;
    width: 50%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 8888;
  }
}
</style>
